import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5557ace8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_2 = { class: "area-cards-info" }

import { withDefaults, watch, defineAsyncComponent, ref } from 'vue';
import { AtomInfoCard, AtomToogleButton } from '@/components/atoms';
import * as icons from '@/components/atoms';

import { MoleculeCard } from '.';
import { IDataInfo, IToggleButon } from '@/types';
interface IProps {
  data: IDataInfo[];
  hasToggle?: boolean;
  buttons?: IToggleButon[];
  title: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeConsumoInternet',
  props: {
    data: null,
    hasToggle: { type: Boolean, default: false },
    buttons: null,
    title: null
  },
  emits: ['handleToggle'],
  setup(__props: any, { emit }) {

const props = __props as { data: IDataInfo[], hasToggle: boolean, buttons?: IToggleButon[], title: string };

const mapComp = {};


props.data.map((data, index) => {
  data.order = index;
});

for (const iterator of props.data.filter((f) => f.icon)) {
  mapComp[String(iterator.order)] = icons[String(iterator.icon)];
}
const toggleBtn = ref('');
console.log(mapComp);
console.log(props.data, 'data');
watch(
  () => props.data,
  () => {
    props.data.map((data, index) => {
      data.order = index;
    });

    for (const iterator of props.data.filter((f) => f.icon)) {
      mapComp[String(iterator.order)] = icons[String(iterator.icon)];
    }
  }
);
watch(
  () => toggleBtn.value,
  () => {
    console.log(toggleBtn.value);
    emit('handleToggle', toggleBtn.value);
  }
);
function handleToogleChange($event) {
  emit('handleToggle', $event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MoleculeCard), { title: __props.title }, {
    default: _withCtx(() => [
      (props.hasToggle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(AtomToogleButton), {
              buttons: props.buttons ?? [],
              onHandleToggle: handleToogleChange
            }, null, 8, ["buttons"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (info, index) => {
          return (_openBlock(), _createBlock(_unref(AtomInfoCard), {
            key: String(index),
            number: info.number,
            description: info.description,
            noBorder: info.noBorder,
            hasIcon: !!info.icon
          }, _createSlots({ _: 2 }, [
            (info.icon)
              ? {
                  name: "icon",
                  fn: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(mapComp[String(info.order)])))
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["number", "description", "noBorder", "hasIcon"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})